// utils/notify.js
// import axios from "axios";

// const API_URL = process.env.REACT_APP_API_BASE_URL

// export const sendNotification = async (title, body, staffId) => {
//   try {
//     const response = await axios.post(`${API_URL}notify/add`, {
//       title,
//       body,
//       staffId,
//     });

//     return response.data;
//   } catch (error) {
//     console.error("Error sending notification:", error);
//     throw error;
//   }
// };
// utils/notify.js
import axios from "axios";

 const apiUrl = process.env.REACT_APP_API_BASE_URL;

export const sendNotification = async (title, body, staffId) => {
  try {
    const response = await axios.post(`${apiUrl}notify/add`, {
      title,
      body,
      staffId,
    });
    return response.data;
  } catch (error) {
    console.error("Error sending notification:", error);
    throw error;
  }
};
